import './ShareModal.scss';

import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useArtistContext } from '../ArtistPageContext';

export default function ShareModal({ show, handleClose }) {
  const { artist } = useArtistContext();
  const qrRef = useRef();

  const shareLink = `${process.env.REACT_APP_WEBSITE_URL}/a/${artist.display_name}`;

  const downloadQR = () => {
    const canvas = qrRef.current;
    if (!canvas) return;

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const link = document.createElement("a");
    link.href = pngUrl;
    link.download = `${artist.display_name}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal className="__share-modal" show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Share your Artist Profile</Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-body">
        { shareLink && (
          <div className="mb-4">
            <QRCodeCanvas ref={ qrRef } value={ shareLink } size={ 200 } />
          </div>
        ) }

        <Button className="ppy-btn ppy-btn-primary mb-3" onClick={ downloadQR }>
          Download QR Code
        </Button>

        <Form.Control
          value={ shareLink }
          readOnly
          onClick={ (e) => e.target.select() }
        />
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-primary" onClick={ handleClose }>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
